var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _polygon, _polygon2, _polygon3, _polygon4, _g2, _polygon5, _g3, _polygon6, _g4, _polygon7, _g5, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMercoVhc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:#BF7600;}\n\t.st1{opacity:0.5;fill:url(#SVGID_1_);}\n\t.st2{display:none;fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st3{opacity:0.5;fill:url(#SVGID_2_);}\n\t.st4{display:none;opacity:0.5;fill:#BF7600;}\n\t.st5{display:none;}\n\t.st6{display:inline;}\n\t.st7{display:inline;fill:none;stroke:#808080;stroke-miterlimit:10;}\n\t.st8{fill:#CCCCCC;}\n\t.st9{fill:#808080;}\n\t.st10{opacity:0.5;fill:#808080;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{opacity:0.5;}\n\t.st13{fill:#0AAEFF;}\n\t.st14{display:inline;fill:none;stroke:#DB9A00;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st15{display:inline;fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("symbol", {
    id: "Bowl",
    viewBox: "-90.4 -47.4 157.3 94.8"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-56.5-38.5c0.4-1,1.2-2,2.5-2.3l21.6-5.8c6.4-1.7,13.2-0.8,19,2.5l67.6,39c1,0.6,1.4,1.6,1.8,2.6 c2.3,7,9.7,32.1,10.4,36.2c0.3,1.9-0.8,4-3,4.6l-30.4,8.2c-6.8,1.8-14,0.9-20-2.6L-64.4-0.7c-1.8-1.1-2.4-3.1-1.9-4.8 C-64.3-12.7-57.8-35.3-56.5-38.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-56.5-38.5c-0.5,1.5,0,3.3,1.6,4.2l67.6,39c5.8,3.3,12.6,4.2,19,2.5l21.6-5.8c1.9-0.5,2.9-2.3,2.6-4 c-0.3-1-0.7-2-1.8-2.6l-67.6-39c-5.8-3.3-12.6-4.2-19-2.5L-54-40.8C-55.3-40.4-56.2-39.5-56.5-38.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-56.5-38.5c0.4-1.1,1.2-2,2.5-2.3l21.6-5.8c6.4-1.7,13.2-0.8,19,2.5l67.6,39c1,0.6,1.4,1.6,1.8,2.6 c2.8,8.4,10.4,36.2,10.4,36.2c-0.2-1.2-0.8-2.3-2-3L-13-13.8c-6.1-3.5-13.2-4.4-20-2.6l-30.4,8.1c-1.5,0.4-2.5,1.5-2.9,2.8 C-66.3-5.6-59-31.6-56.5-38.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -60.2497,
    y1: -25.9763,
    x2: -54.6828,
    y2: -24.5592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-66.3-5.4c0.5-1.7,1.8-2.6,2.7-2.9c1.1-0.3,11.9-3.2,11.9-3.2l8.7-32.3c0,0-10.2,2.5-11.6,3.2 c-0.9,0.4-1.5,1-1.9,2.1C-57.7-35.4-66.3-5.4-66.3-5.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.4,33.7c-0.2-1.2-0.8-2.3-2-3L-13-13.8c-6.1-3.5-13.2-4.4-20-2.6l-30.4,8.1c-1.5,0.4-2.5,1.5-2.9,2.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.0375,
    y1: -30.6275,
    x2: -13.0385,
    y2: -30.6275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5062,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-13.5-44.1c-5.8-3.3-12.6-4.2-19-2.5L-33-16.5c6.8-1.8,13.9-0.9,20,2.6L-13.5-44.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-33.3-16.4l-34.8-20.3c-4.3-2.2-12.2-2.8-17.6-1.3c-5.4,1.4-6.2,4.4-1.9,6.5l34.8,20.3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 250,
    cy: 250,
    r: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 0,
    y1: 250,
    x2: 500,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 250,
    y1: 500,
    x2: 250,
    y2: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "63.2,371.5 63.2,150.2 213.8,63.3 438.4,123.4 438.4,344.8 287.8,431.7  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "63.2,150.2 223.2,193.1 223.1,279.2 63.2,371.5  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "63.2,371.5 223.1,279.2 223.2,414.1  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "63.2,371.5 287.8,431.7 438.4,344.8 213.8,284.6  "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M266,306l-42.9-11.5c-9.5-2.6-19.7-1.2-28.2,3.7L85.9,361.1c-2.6,1.5-3.4,4.4-2.7,6.8 c0.5,1.8,1.9,3.4,4.1,3.9l42.9,11.5c9.5,2.5,19.7,1.2,28.2-3.7l109-62.9c1.7-1,2.6-2.5,2.9-4.2C270.8,309.8,269.1,306.8,266,306z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M339.7,325.8l-42.9-11.5c-9.5-2.6-19.7-1.2-28.2,3.7l-108.9,62.9c-2.6,1.5-3.4,4.4-2.7,6.8 c0.5,1.8,1.9,3.4,4.1,3.9l42.9,11.5c9.5,2.5,19.7,1.2,28.2-3.7l109-62.9c1.7-1,2.6-2.5,2.9-4.2 C344.5,329.6,342.9,326.6,339.7,325.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bowl",
    width: 157.3,
    height: 94.8,
    x: -90.4,
    y: -47.4,
    transform: "matrix(1.41 0 0 -1.41 176.6857 307.2972)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bowl",
    width: 157.3,
    height: 94.8,
    x: -90.4,
    y: -47.4,
    transform: "matrix(1.41 0 0 -1.41 252.2164 325.8602)",
    style: {
      overflow: "visible"
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "63.2,316.2 287.8,376.4 438.4,289.4 213.8,229.3  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M266,251.8l-42.9-11.5c-9.5-2.6-19.7-1.2-28.2,3.7L85.9,306.9c-2.6,1.5-3.4,4.4-2.7,6.8 c0.5,1.8,1.9,3.4,4.1,3.9l42.9,11.5c9.5,2.5,19.7,1.2,28.2-3.7l109-62.9c1.7-1,2.6-2.5,2.9-4.2C270.8,255.6,269.1,252.6,266,251.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M339.7,271.5L296.8,260c-9.5-2.6-19.7-1.2-28.2,3.7l-108.9,62.9c-2.6,1.5-3.4,4.4-2.7,6.8 c0.5,1.8,1.9,3.4,4.1,3.9l42.9,11.5c9.5,2.5,19.7,1.2,28.2-3.7l109-62.9c1.7-1,2.6-2.5,2.9-4.2 C344.5,275.4,342.9,272.4,339.7,271.5z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bowl",
    width: 157.3,
    height: 94.8,
    x: -90.4,
    y: -47.4,
    transform: "matrix(1.41 0 0 -1.41 176.6857 255.1276)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bowl",
    width: 157.3,
    height: 94.8,
    x: -90.4,
    y: -47.4,
    transform: "matrix(1.41 0 0 -1.41 252.2164 273.6905)",
    style: {
      overflow: "visible"
    }
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "63.2,260.9 287.8,321 438.4,234.1 213.8,173.9  "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M266,196.3l-42.9-11.5c-9.5-2.6-19.7-1.2-28.2,3.7L85.9,251.4c-2.6,1.5-3.4,4.4-2.7,6.8 c0.5,1.8,1.9,3.4,4.1,3.9l42.9,11.5c9.5,2.5,19.7,1.2,28.2-3.7l109-62.9c1.7-1,2.6-2.5,2.9-4.2C270.8,200.2,269.1,197.2,266,196.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M339.7,216.1l-42.9-11.5c-9.5-2.6-19.7-1.2-28.2,3.7l-108.9,62.9c-2.6,1.5-3.4,4.4-2.7,6.8 c0.5,1.8,1.9,3.4,4.1,3.9l42.9,11.5c9.5,2.5,19.7,1.2,28.2-3.7l109-62.9c1.7-1,2.6-2.5,2.9-4.2C344.5,219.9,342.9,217,339.7,216.1 z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bowl",
    width: 157.3,
    height: 94.8,
    x: -90.4,
    y: -47.4,
    transform: "matrix(1.41 0 0 -1.41 176.6857 198.728)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bowl",
    width: 157.3,
    height: 94.8,
    x: -90.4,
    y: -47.4,
    transform: "matrix(1.41 0 0 -1.41 252.2164 217.2909)",
    style: {
      overflow: "visible"
    }
  }), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "63.2,205.5 287.8,265.7 438.4,178.8 213.8,118.6  "
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M266,140.9l-42.9-11.5c-9.5-2.6-19.7-1.2-28.2,3.7L85.9,196c-2.6,1.5-3.4,4.4-2.7,6.8 c0.5,1.8,1.9,3.4,4.1,3.9l42.9,11.5c9.5,2.5,19.7,1.2,28.2-3.7l109-62.9c1.7-1,2.6-2.5,2.9-4.2C270.8,144.7,269.1,141.7,266,140.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M339.7,160.7l-42.9-11.5c-9.5-2.6-19.7-1.2-28.2,3.7l-108.9,62.9c-2.6,1.5-3.4,4.4-2.7,6.8 c0.5,1.8,1.9,3.4,4.1,3.9L204,238c9.5,2.5,19.7,1.2,28.2-3.7l109-62.9c1.7-1,2.6-2.5,2.9-4.2C344.5,164.5,342.9,161.5,339.7,160.7 z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bowl",
    width: 157.3,
    height: 94.8,
    x: -90.4,
    y: -47.4,
    transform: "matrix(1.41 0 0 -1.41 176.6857 141.8583)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bowl",
    width: 157.3,
    height: 94.8,
    x: -90.4,
    y: -47.4,
    transform: "matrix(1.41 0 0 -1.41 252.2164 160.4213)",
    style: {
      overflow: "visible"
    }
  }), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "63.2,150.2 287.8,210.4 438.4,123.4 213.8,63.3  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "287.8,210.4 287.8,431.7 438.4,344.8 438.4,123.4  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "223.2,193.1 223.2,414.6 287.8,432 287.8,210.4  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "223.2,193.1 223.2,295.8 287.8,313.1 287.8,210.4  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.9,397.4 244.9,410.1 265.6,415.7 265.6,402.9  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "235.2,210.4 235.2,284.9 275.3,295.7 275.3,221.1  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "H2",
    className: "st5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: -1350.5,
    y1: 165,
    x2: 694.2,
    y2: 712.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -720.3,
    y1: 120.5,
    x2: 1324.4,
    y2: 668.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -720.3,
    y1: -36.5,
    x2: 1324.4,
    y2: 511.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -736.1,
    y1: 32.2,
    x2: 1308.6,
    y2: 580
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -263.3,
    y1: 541,
    x2: 1654.2,
    y2: -566.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -284.3,
    y1: 514.4,
    x2: 1633.1,
    y2: -592.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -367.4,
    y1: 514.4,
    x2: 1550.1,
    y2: -592.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -450.4,
    y1: 514.4,
    x2: 1467.1,
    y2: -592.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 115.7,
    y1: -425.3,
    x2: 115.7,
    y2: 1218.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 172.5,
    y1: -391.3,
    x2: 172.5,
    y2: 1252.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 275,
    y1: -386.5,
    x2: 275,
    y2: 1257.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -256.5,
    y1: 694,
    x2: 1661,
    y2: -413
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -400.7,
    y1: 642.7,
    x2: 1516.8,
    y2: -464.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 381.8,
    y1: -460.3,
    x2: 381.8,
    y2: 1183.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -707.2,
    y1: -123.3,
    x2: 1337.5,
    y2: 424.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 229.2,
    y1: -409.7,
    x2: 229.2,
    y2: 1234.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercoVhc);
export default __webpack_public_path__ + "static/media/mercoVHC.59249f656e75db9b73e6253e9313e6ff.svg";
export { ForwardRef as ReactComponent };